import { useEffect, useState } from "react";

export default function useChatTyping(socket: any, jobId: string, participantId: string) {
  const [isTyping, setIsTyping] = useState(false);
  useEffect(() => {
    setIsTyping(false);
    if (!socket || !jobId || !participantId) return;
    const handleTyping = (event: any) => {
      if (event?.jobId === jobId && event?.senderId === participantId && typeof event.typing === "boolean") {
        setIsTyping(event.typing);
      }
    };
    const clear = () => setIsTyping(false);
    const presence = (event: any) => {
      if (event?.userId === participantId && event.isOnline === false) clear();
    };
    socket.on("job:chat:typing", handleTyping);
    socket.on("disconnect", clear);
    socket.on("presence.update", presence);
    return () => {
      socket.off("job:chat:typing", handleTyping);
      socket.off("disconnect", clear);
      socket.off("presence.update", presence);
    };
  }, [socket, jobId, participantId]);
  return isTyping;
}
